import { Heading } from '@thirstycamel/ui'
import { useWindowSize } from '../../pages/hump-club'
import React from 'react'

export default function HumpClubLandingOffersGrid({ offers }: { offers: any }) {
  const isMobile = useWindowSize()

  return (
    <>
      <div style={{ position: 'relative' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom: '5rem',
            marginTop: '1rem',
          }}
        >
          {' '}
          <div className="heading-red">Hump Club members get</div>
          <div className="heading-green">
            <img
              src="/static/images/hump-club-landing/UnlimitedMyOffers.png"
              alt="Hump Club Logo"
              style={{
                width: isMobile ? '85%' : '60%',
                display: 'block',
                margin: '0 auto',
                marginTop: isMobile ? '-0.1rem' : '-0.4rem',
                marginBottom: isMobile ? '0rem' : '-0.4rem',
              }}
            />
          </div>
          <div className="heading-red">PLUS loads of member only perks</div>
        </div>
      </div>
      <div className="offers-grid-container">
        <div className="offers-grid">
          {offers.map((offer, index) => (
            <div key={index} className="offer-container">
              <div className={`offer-text ${offer.textPosition === 'top' ? 'offer-text-top' : ''}`}>
                {offer.text.split('\n').map((line, i) => (
                  <React.Fragment key={i}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </div>
              <img
                src={offer.image}
                alt={offer.text}
                className="offer-image"
                style={offer.textPosition === 'top' ? { marginTop: '3rem' } : {}}
              />
            </div>
          ))}
        </div>
        <div
          className="hump-club-body-text"
          style={{ width: isMobile ? '80%' : '50%', marginTop: isMobile ? '0.5rem' : '0rem' }}
        >
          Use your mobile number at your local Thirsty Camel or when you shop online to keep earning
          rewards. Every dollar you spend gets you one step closer to a bunch of surprise treats
          along the way.
        </div>
      </div>
    </>
  )
}
